import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62c82bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-wrapper" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "card-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "card-img-top",
      src: _ctx.product.imagePath,
      alt: _ctx.product.name,
      loading: "lazy"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.product.name), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.createdDate), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary w-100 rounded-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tryIt && _ctx.tryIt(...args)))
      }, " Try it ")
    ])
  ]))
}